<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          :showBtn="false"
          :showSettingBtn="false"
          :showAddNew="false"
          title="PR Stock Transfer List"
          @onClickCloseButton="goBack"
      />
      <DateQuerySetter @onClickGo="getPRStockTransferList">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label for="colFormLabel" class="col-form-label">Requisition Number</label>
          <input class="form-control" type="text" v-model="requisition_number">
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3">
          <label class="col-form-label">Location</label>
          <vField v-model="location_id" class="d-none" name="location_id"/>
          <v-select
              placeholder="Select Location"
              v-model="location_id"
              :options="locations"
              label="name"
              :reduce="name => name.id"
          />
        </div>
      </DateQuerySetter>
    </div>

    <ListTable 
      :data="prStockTransferList" 
      @onView="onView"
    />
    <div class="mb-2"></div>
  </div>
  <GlobalLoader/>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton'
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import ListTable from './PRStockTransferListTable.vue'
import handleRequisitions from "@/services/modules/procurement/requisition";
import { useRoute, useRouter } from "vue-router";
import { ref, onMounted, computed } from "vue";
import { inject } from 'vue';

const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const { fetchPRStockTransferList } = handleRequisitions();

const companyId = computed(() => route.params.companyId);

const prStockTransferList = ref([]);
const requisition_number = ref('');
const location_id = ref(null);
const locations = ref([]);

function getQuery() {
  let query = '?company_id=' + companyId.value
  query += '&start_date=' + route.query.start
  query += '&end_date=' + route.query.end
  query += requisition_number.value ? '&requisition_number=' + requisition_number.value : ''
  query += location_id.value ? '&location_id=' + location_id.value : ''
  return query;
}

const getPRStockTransferList = () => {
  fetchPRStockTransferList(getQuery()).then(res => {
    if(!res.status) {
      return;
    }
    prStockTransferList.value = res.data;
  });
};

const onView = (data) => {
  router.push({
    name: 'pr-stock-transfer-add',
    params: {
      companyId: companyId.value,
      moduleId: route.params.moduleId,
      menuId: route.params.menuId,
      pageId: data.location_id,
      locationId: data.location_id
    },
    query: {
      start: route.query.start,
      end: route.query.end
    }
  });
};

const goBack = () => {
  router.back();
};

onMounted(() => {
  getPRStockTransferList();
});
</script>
